import { googleCaptchaSitekeyV3, sitecoreApiKey } from '@shared/configs/configs/config';
import { CREATE_SUBSCRIPTION_NEWSLETTER_URL } from '@shared/utils/api/configs/URL';
import { convertToBase64 } from '@shared/utils/string';

interface HandleSecureActionOptions {
  email: string; // email to encode and use in URL
  onError?: (error: unknown) => void; // optional error handler
  onFinally?: () => void; // optional cleanup
  onValidate: (token: string) => Promise<boolean>; // validate token (API call)
}

/**
 * Opens a tab safely and runs async work protected by Google reCAPTCHA v3.
 */
export const handleNewsLetterSubscriptionWithNewTab = async ({
  onValidate,
  email,
  onError,
  onFinally,
}: HandleSecureActionOptions) => {
  try {
    window.grecaptcha.ready(async () => {
      const token = await window.grecaptcha.execute(googleCaptchaSitekeyV3(), { action: 'submit' });
      const isValid = await onValidate(token);

      if (isValid) {
        const base64 = convertToBase64(email);
        const trimmed = base64.endsWith('=') ? base64.slice(0, base64.indexOf('=')) : base64;
        const encodedValue = trimmed.replace(/\+/g, '-').replace(/\//g, '_');
        const url = `${CREATE_SUBSCRIPTION_NEWSLETTER_URL}?sc_apikey=${sitecoreApiKey()}&em=${encodedValue}`;
        window.location.href = url;
      }
    });
  } catch (error) {
    console.error('Secure action failed:', error);
    onError?.(error);
  } finally {
    onFinally?.();
  }
};
